<template>
  <b-card class="molecule-progress-bar_card">
    <div v-if="title || subTitle" class="molecule-progress-bar_header">
      <div v-if="title" class="header__title">{{ title }}</div>
      <div v-if="subTitle" class="header__sub-title">{{ subTitle }}</div>
    </div>
    <div class="molecule-progress-bar_graph">
      <div
        v-for="(item, index) in dataset"
        :key="index"
        :class="{ 'margin-top-20px': index != 0 }"
      >
        <atom-doughnut-chart
          :title="item.title"
          :subTitle="item.subTitle"
          :color="item.color"
          :value="item.value"
          :max="item.max"
        ></atom-doughnut-chart>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue"
import AtomDoughnutChart from "@/components/atoms/graphs/AtomDoughnutChart.vue"
export default {
  name: "MoleculeDoughnutChartList",
  components: { BCard, AtomDoughnutChart },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    dataset: {
      type: Array,
      required: true,
      // value = [ { title, subTitle, color, value, max}]
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 0;
}

.molecule-progress-bar_card {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

// header
.molecule-progress-bar_header {
}
.header__title {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
}
.header__sub-title {
  color: #b9b9c3;
  font-size: 12px;
  margin-top: 8px;
}

// graph
.molecule-progress-bar_graph {
  margin-top: 20px;
  margin-bottom: 10px;
  padding-top: 10px;
  padding-right: 20px;
  width: 100%;
  max-height: 250px;
  overflow-y: auto;
}

// margin-top-20px
.margin-top-20px {
  margin-top: 20px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
